import * as yup from 'yup';

export const updateRoomValidations = yup.object({
  title: yup.string().required().min(1).max(30).label('Title'),
  description: yup.string().required().min(1).max(250).label('Description'),
  code: yup
    .string()
    .matches(/^\w[\w-]*$/, 'Room Code must be valid')
    .required()
    .label('Room Code'),
  timeToComplete: yup
    .number()
    .integer('Room completion time must be a whole number')
    .required()
    .min(1)
    .max(99_999)
    .typeError('Room completion time must be a number')
    .label('Room completion time'),
});

export const THMRoomTypeOptions = [
  { id: 'tryhackme', label: 'TryHackMe', value: 'tryhackme', name: 'roomCreatorType' },
  { id: 'community', label: 'Community', value: 'community', name: 'roomCreatorType' },
];
